import React, { FC, useEffect, useState } from 'react'
import { Row, Spin } from 'antd'

import { serviceProviderService } from '../../../services'
import { ReportEntry, RequestErrorInterface, RequestErrorObject } from '../../../types'
import { handleError, RealtimeReport, CsvReport } from '../../../components'

interface ReportProps {
	serviceProviderId: number
	serviceProviderName: string
}

const Report: FC<ReportProps> = ({ serviceProviderId, serviceProviderName }) => {
	const [report, setReport] = useState<ReportEntry[]>()
	const [loading, setLoading] = useState<boolean>(false)

	const handleReportError = (error: RequestErrorInterface): RequestErrorObject => {
		const source = 'Report Error'
		const base = { source, status: error.response.status }

		return { ...base, description: 'There was an unexpected problem when attempting to retrieve the report' }
	}

	useEffect(() => {
		const getData = async () => {
			try {
				setLoading(true)
				const { data } = await serviceProviderService.getReport(serviceProviderId)
				setReport(data)
				setLoading(false)
			} catch (error) {
				handleError(error, handleReportError)
			}
		}

		getData()
	}, [serviceProviderId])

	const serviceProviderHasResellers = report?.length > 0

	return (
		<div className='report'>
			{loading ? (
				<Spin className='center' tip='Loading report' />
			) : serviceProviderHasResellers ? (
				<>
					<Row type='flex' justify='end' style={{ marginBottom: '1rem' }}>
						<CsvReport entityId={serviceProviderId} entityName={serviceProviderName} type={'serviceprovider'} />
					</Row>
					{report?.map(reseller => (
						<RealtimeReport key={reseller.id} reportEntry={reseller} />
					))}
				</>
			) : (
				<div className='no-results'>No resellers assigned</div>
			)}
		</div>
	)
}

export default Report
